import { defineMessages } from 'react-intl';

export const bulkHarmonizationMessages = defineMessages({
  generateBulkCodes: {
    description: 'Button text to start bulk harmonization generation',
    defaultMessage: 'Generate HS Codes',
    id: 'uIINJ3',
  },
  bulkeGenerateButtonDisabledTooltip: {
    description: 'Tooltip message explaining why bulk generate button is disabled',
    defaultMessage: 'Select up to 10 products to generate Harmonized System codes',
    id: 'xofD7F',
  },
  bulkResultsTitle: {
    description: 'Modal title for bulk harmonization results',
    defaultMessage: 'Harmonization Code Results',
    id: 'qWjKnn',
  },
  productsWithoutDescriptions: {
    description: 'Warning about products without descriptions',
    defaultMessage: '<i>{count, plural, one {# product} other {# products}} had no description - results may be less accurate</i>',
    id: 'ee/FzP',
  },
  thinking: {
    description: 'Loading message while fetching bulk results',
    defaultMessage: 'Thinking...',
    id: 'cbZ4bX',
  },
  acceptAllHighConfidence: {
    description: 'Button text to accept all high confidence suggestions',
    defaultMessage: 'Accept All High Confidence',
    id: 'H8BRdH',
  },
  highConfidenceSummary: {
    description: 'Summary banner showing count of products with high confidence suggestions',
    defaultMessage: '{count, plural, one {# product has} other {# products have}} high confidence suggestions',
    id: 'WPIgaz',
  },
  saveAll: {
    description: 'Button text to save all accepted changes',
    defaultMessage: 'Save Accepted Codes ({count})',
    id: 'SnR/Uy',
  },
  noSuggestionsAvailable: {
    description: 'Message when no suggestions are returned',
    defaultMessage: 'No suggestions available for this product',
    id: 'TTIADb',
  },
});
